import React, { useState } from "react";
import Header1 from "./ptfHeader";

const faqs = [
  {
    q: "What is MyCafe Connect?",
    a: "MyCafe Connect is a corporate dining mobile application that enables employees to order food, make payments, and track orders seamlessly.",
  },
  {
    q: "How does the app reduce waiting time?",
    a: "Employees can pre-order meals and choose pickup time slots, eliminating long cafeteria queues.",
  },
  {
    q: "Is MyCafe Connect available for both Android and iOS?",
    a: "Yes, the app is available on both Android and iOS platforms.",
  },
  {
    q: "What payment methods are supported?",
    a: "We support UPI, debit/credit cards, net banking, and corporate wallet options.",
  },
  {
    q: "Can I track my order in real time?",
    a: "Yes, the app provides live tracking from kitchen preparation to delivery or pickup.",
  },
  {
    q: "Is the app secure for online payments?",
    a: "Yes, all transactions are encrypted and processed through secure payment gateways.",
  },
  {
    q: "Can companies customize menus?",
    a: "Yes, corporate clients can customize menus and pricing as per their requirements.",
  },
  {
    q: "Does the app support bulk ordering?",
    a: "Yes, users can place bulk orders for meetings or corporate events.",
  },
  {
    q: "Can I view my past orders?",
    a: "Yes, the app maintains a complete order history for easy tracking and reordering.",
  },
  {
    q: "Does the app offer reward points?",
    a: "Yes, users earn reward points on purchases which can be redeemed later.",
  },
  {
    q: "How do I provide feedback?",
    a: "Users can rate and provide feedback after each completed order.",
  },
  {
    q: "Is there a minimum order value?",
    a: "Minimum order values may vary depending on corporate policy.",
  },
  {
    q: "Can I cancel my order?",
    a: "Orders can be cancelled within a specific time window before preparation begins.",
  },
  {
    q: "Is customer support available?",
    a: "Yes, support is available through the app and via corporate helpdesk.",
  },
  {
    q: "Does it support multiple cafeterias?",
    a: "Yes, organizations with multiple cafeterias can manage all locations in one platform.",
  },
  {
    q: "Can employees schedule meals in advance?",
    a: "Yes, pre-scheduling meals for future dates is supported.",
  },
  {
    q: "Does MyCafe Connect reduce food wastage?",
    a: "Yes, demand forecasting helps cafeterias prepare accurate quantities.",
  },
  {
    q: "Is the app suitable for large enterprises?",
    a: "Yes, it is scalable and designed for enterprises of all sizes.",
  },
  {
    q: "Does it integrate with HR systems?",
    a: "Yes, the system can integrate with payroll and employee ID systems.",
  },
  {
    q: "Is training required to use the app?",
    a: "No, the app is designed with an intuitive interface requiring minimal training.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <Header1 />
      <div className="container mx-auto mt-28 mb-16 px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-gray-500 mb-12">
            Everything you need to know about{" "}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>
          </p>
        </div>

        {/* FAQ Items */}
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md border-l-4 border-blue-600 mb-5 transition hover:shadow-lg"
          >
            {/* Question */}
            <button
              onClick={() => toggle(index)}
              className="w-full text-left px-6 py-4 flex justify-between items-center font-semibold text-gray-800"
            >
              {faq.q}
              <span className="text-xl text-blue-600">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>

            {/* Answer */}
            <div
              className={`px-6 pb-5 text-gray-600 leading-relaxed transition-all duration-300 overflow-hidden ${
                activeIndex === index
                  ? "max-h-96 opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              {faq.a}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
